import settings from "../../config/settings"
const axios = require("axios");

export default class DeviceService {

    getDevicesList =async (userId:any) => {
        let token = localStorage.getItem('keycloak-token');
        const params = new URLSearchParams({
            user_id: userId,
        })
        return await axios.get(settings.apiUrl + 'devices?' + params,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
        }
        }).then((resp: any) => resp.data);   
    }

    getDeviceDetails =async (userId:any, projectName: string, did: string) => {
        let token = localStorage.getItem('keycloak-token');
        const user_id: any = localStorage.getItem('userId') ? localStorage.getItem('userId') : ''
        const params = new URLSearchParams({
            user_id: user_id,
            project_name: projectName,
            did: did
        })
        return await axios.get(settings.apiUrl + 'device-details?' + params,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
        }
        }).then((resp: any) => resp.data);     
    }

    updateDevice =async (did:string, project_name: string) => {
        let token = localStorage.getItem('keycloak-token');
        let params = new URLSearchParams({
            did: did,
            project_name: project_name
        })
        const projectInfo: any = localStorage.getItem('projectInfo');
        const measurements: any = localStorage.getItem('measurements');
        const deviceMessaging: any = localStorage.getItem('deviceMessaging');
        // const serverMessaging: any = localStorage.getItem('serverMessaging');
        const transferInfo: any = localStorage.getItem('transferInfo');
        let data: any = {
            projectInfo: JSON.parse(projectInfo),
            measurements: JSON.parse(measurements),
            deviceMessaging: JSON.parse(deviceMessaging),
            // serverMessaging: JSON.parse(serverMessaging),
            transferInfo: JSON.parse(transferInfo),
        }
        return await axios.put(settings.apiUrl + 'device-details?' + params , data,
        {
            headers:{
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
        }
        }).then((resp: any) => resp.status);
    }
}